import { render, staticRenderFns } from "./AppPublicFooter.vue?vue&type=template&id=31202489&scoped=true"
import script from "./AppPublicFooter.vue?vue&type=script&lang=js"
export * from "./AppPublicFooter.vue?vue&type=script&lang=js"
import style0 from "./AppPublicFooter.vue?vue&type=style&index=0&id=31202489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31202489",
  null
  
)

export default component.exports